import React, { useState } from "react";

import ExpiredLink from "../../components/forgetPassword/ExpiredLink";
import { Grid, Typography } from "@mui/material";
import "./linkExpired.scss";
const ForgetPassword = () => {
  const [linkExpired, setLinkExpired] = useState(false);
  const [authToken, setAuthToken] = useState("");

  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        className="register-page"
      >
        <Grid
          container
          direction="column"
          marginTop="3rem"
          padding="1rem"
          width="30%"
          className="main-div"
        >
          <ExpiredLink />
        </Grid>
      </Grid>
    </>
  );
};

export default ForgetPassword;
